import { useEffect } from "react";
import { tapToast } from "./useToast";
import type { ToastOptions } from "./useToast";

export type ToastHaptics = {
  success?: () => void;
  danger?: () => void;
};

const withHaptics = (haptics: ToastHaptics) => (toast: ToastOptions) => {
  if (toast.variant === "success" || toast.variant === "danger") {
    haptics[toast.variant]?.();
  }
};

export const useToastHaptics = (haptics?: ToastHaptics) => {
  useEffect(() => {
    if (!haptics) return;
    tapToast(withHaptics(haptics));
  }, [haptics?.success, haptics?.danger]);
};
